import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import CancelIcon from "@material-ui/icons/Cancel";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { toast } from "react-toastify";

const InfoMP = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const webhookUrl = `${backendUrl}/subscription/mercadopagowebhook`;

  const handleCopy = async (text, label) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${label} copiado!`);
    } catch {
      toast.error("Não foi possível copiar.");
    }
  };

  return (
    <div>
      <IconButton onClick={() => setOpen(true)} aria-label="Manual de integração Mercado Pago">
        <InfoIcon style={{ color: "black" }} />
      </IconButton>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: theme.palette.background.paper,
            padding: "24px",
            borderRadius: "8px",
            outline: "none",
            maxWidth: "720px",
            width: "92%",
            maxHeight: "85vh",
            overflow: "auto",
            color: theme.palette.text.primary,
          }}
        >
          <IconButton
            style={{ position: "absolute", top: "8px", right: "8px" }}
            onClick={() => setOpen(false)}
          >
            <CancelIcon />
          </IconButton>

          <Typography variant="h5" gutterBottom>
            Manual — Integração Mercado Pago (assinaturas)
          </Typography>

          <Typography variant="body2" color="textSecondary" paragraph>
            Configure cobrança recorrente de licenças com cliente vinculado por e-mail e CPF/CNPJ.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>1. Conta e credenciais</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Acesse{" "}
            <a href="https://www.mercadopago.com.br/developers" target="_blank" rel="noopener noreferrer">
              Mercado Pago Developers
            </a>
            , crie uma aplicação e copie o <strong>Access Token</strong> de produção ou teste.
            Cole no campo <strong>Access Token</strong> abaixo. Para testes, marque{" "}
            <strong>Usar sandbox Mercado Pago</strong>.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>2. Meio de pagamento ativo</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Em <strong>Cobrança / Pagamentos</strong>, selecione <strong>Mercado Pago</strong> como gateway
            ativo (somente um por vez).
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>3. URL de notificação (webhook)</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            No painel MP: <em>Suas integrações → Webhooks</em>. Cadastre a URL abaixo e ative eventos de{" "}
            <strong>pagamentos</strong> (<code>payment.created</code>, <code>payment.updated</code>).
            Você pode colar a mesma URL no campo <strong>URL de notificação MP</strong> (opcional — se vazio,
            o sistema usa a URL padrão abaixo).
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            mb={2}
            p={1.5}
            bgcolor={theme.palette.action.hover}
            borderRadius={4}
            style={{ gap: 8 }}
          >
            <Typography variant="body2" component="code" style={{ wordBreak: "break-all", flex: 1 }}>
              {webhookUrl}
            </Typography>
            <Button
              size="small"
              variant="outlined"
              startIcon={<FileCopyIcon />}
              onClick={() => handleCopy(webhookUrl, "URL do webhook")}
            >
              Copiar URL
            </Button>
          </Box>

          <Typography variant="subtitle1" gutterBottom>
            <strong>4. Cadastro das empresas clientes</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Cada empresa precisa de <strong>CPF/CNPJ</strong> e <strong>e-mail</strong> válidos. O sistema
            cria/vincula o cliente no Mercado Pago e uma assinatura (<em>preapproval</em>) automaticamente.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>5. Valor mínimo</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Cobranças só são geradas para planos com valor <strong>acima de R$ 10,00</strong> (mínimo efetivo:{" "}
            <strong>R$ 10,01</strong>).
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>6. Experiência do cliente</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Na primeira cobrança, o cliente autoriza a assinatura no Mercado Pago. Depois, no checkout aparecem
            PIX (se disponível), link de pagamento e opção de <strong>baixar boleto</strong> quando o MP gerar
            o ticket.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>7. Confirmação automática</strong>
          </Typography>
          <Typography variant="body2">
            Quando o pagamento for <strong>approved</strong>, o webhook renova a licença (+30 dias) e reativa
            conexões conforme configurado no sistema.
          </Typography>
        </div>
      </Modal>
    </div>
  );
};

export default InfoMP;
